import React from 'react';
import { COND_TIPO_OS_FIELDS } from '../../process-config/components/condicoesIntervShared';
import {
  DASH_VISIBILITY_KEYS,
  OVERVIEW_VISIBILITY_KEYS,
  isOverviewCustomized,
  normalizeDashboardVisibility,
  normalizeOverviewVisibility,
} from './permDashVisibility';
import { isAvailabilityIndexConfigured } from './PermDisponibilidadeIndexEditor';
import './PermCfgTooltip.css';

const isOn = (v) => v === 1 || v === true || v === '1';

export const PERM_CFG_TIP_PORTAL_CLASS = 'perm-cfg-tip-portal';

function TipShell({ title, sections }) {
  return (
    <span className="perm-cfg-tip">
      <span className="perm-cfg-tip-title">{title}</span>
      {sections.map((s) => (
        <span key={s.label} className="perm-cfg-tip-sec">
          <span className="perm-cfg-tip-sec-label">{s.label}</span>
          {s.chips?.length ? (
            <span className="perm-cfg-tip-chips">
              {s.chips.map((c) => (
                <span key={c.key || c.text} className={`perm-cfg-tip-chip${c.muted ? ' is-muted' : ''}`}>
                  {c.text}
                </span>
              ))}
            </span>
          ) : (
            <span className="perm-cfg-tip-empty">{s.empty || '—'}</span>
          )}
        </span>
      ))}
    </span>
  );
}

export function hasHiddenDashWidget(techCallCfg) {
  if (!techCallCfg || typeof techCallCfg !== 'object') return false;
  const vis = normalizeDashboardVisibility(techCallCfg);
  return DASH_VISIBILITY_KEYS.some(({ key }) => vis[key] === 0);
}

export function isTechCallConfigured(techCallCfg, overviewVisibility) {
  return (
    isAvailabilityIndexConfigured(techCallCfg) ||
    hasHiddenDashWidget(techCallCfg) ||
    isOverviewCustomized(overviewVisibility)
  );
}

export function BloqueioCfgTip({ row }) {
  const chips = [];
  if (isOn(row.opt_cob_os)) {
    chips.push({ text: `Bloqueio OS · ${Number(row.opt_cob_os_dias) || 0} dia(s)` });
  }
  if (isOn(row.opt_cob_sup)) {
    chips.push({ text: `Bloqueio Pedido · ${Number(row.opt_cob_sup_dias) || 0} dia(s)` });
  }
  return (
    <TipShell
      title="Bloqueio financeiro"
      sections={[{ label: 'Ativos (dias de inadimplência)', chips, empty: 'Nenhum bloqueio' }]}
    />
  );
}

export function PedidoSupCfgTip({ row, options }) {
  const map = {
    contador: row.opt_contador,
    orderQty: row.opt_order_qty,
    orderRma: row.opt_order_rma,
    orderGroup: row.opt_order_group,
  };
  const chips = options.filter((o) => isOn(map[o.key])).map((o) => ({ key: o.key, text: o.label }));
  return (
    <TipShell
      title="Pedido de suprimento"
      sections={[{ label: 'Habilitados', chips, empty: 'Nenhuma opção ativa' }]}
    />
  );
}

export function ChamadoTecCfgTip({ techCallCfg, overviewVisibility }) {
  const ov = normalizeOverviewVisibility(overviewVisibility);
  const ovShown = OVERVIEW_VISIBILITY_KEYS.filter(({ key }) => ov[key] === 1);
  const ai = techCallCfg?.availabilityIndex || {};
  const vis = normalizeDashboardVisibility(techCallCfg);
  const hidden = DASH_VISIBILITY_KEYS.filter(({ key }) => vis[key] === 0);
  const defectCodes = Array.isArray(ai.defectCodes) ? ai.defectCodes : [];
  const statusCodes = Array.isArray(ai.statusCodes) ? ai.statusCodes : [];
  const osKeys = Array.isArray(ai.osTypeKeys) ? ai.osTypeKeys : [];
  const osLabels = COND_TIPO_OS_FIELDS.filter((f) => osKeys.includes(f.db)).map((f) => f.label);

  const defectChips = defectCodes.slice(0, 6).map((c) => ({ key: c, text: c }));
  if (defectCodes.length > 6) defectChips.push({ key: 'more', text: `+${defectCodes.length - 6}`, muted: true });

  return (
    <TipShell
      title="Exibições"
      sections={[
        {
          label: `Visão geral · Exibidos (${ovShown.length})`,
          chips: ovShown.map((h) => ({ key: h.key, text: h.label })),
          empty: 'Nenhum bloco exibido',
        },
        {
          label: `Dashboard · Blocos ocultos (${hidden.length})`,
          chips: hidden.map((h) => ({ key: h.key, text: h.label })),
          empty: 'Todos os blocos exibidos',
        },
        {
          label: `Índice · Defeitos (${defectCodes.length})`,
          chips: defectChips,
          empty: 'Nenhum defeito',
        },
        {
          label: 'Índice · Dedução em status',
          chips: statusCodes.map((c) => ({ key: c, text: c })),
          empty: 'Nenhum status',
        },
        {
          label: 'Índice · Tipos de OS',
          chips: osLabels.map((l) => ({ key: l, text: l })),
          empty: 'Nenhum tipo',
        },
      ]}
    />
  );
}
